//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Fragment } from "vue-fragment";
import CustomField from "../data-inputs/custom-field";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import VuelidateValid from "@Shared/utils/shared-mixins/vuelidate-valid-mixin";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CreateCustomFieldForm",
  components: {
    Fragment,
    CustomField,
    SimpleButton
  },
  mixins: [validationMixin, VuelidateValid],
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  validations: {
    newField: {
      type: {
        required
      },
      name: {
        required
      }
    }
  },
  data() {
    var _this$value$id, _this$value$type, _this$value$name, _this$value$visibilit, _this$value$options, _this$value;
    return {
      saving: false,
      editing: false,
      savingStatus: false,
      newField: {
        id: (_this$value$id = this.value.id) != null ? _this$value$id : undefined,
        type: (_this$value$type = this.value.type) != null ? _this$value$type : "text",
        name: (_this$value$name = this.value.name) != null ? _this$value$name : "",
        visibility: (_this$value$visibilit = this.value.visibility) != null ? _this$value$visibilit : "full",
        options: (_this$value$options = (_this$value = this.value) == null ? void 0 : _this$value.options) != null ? _this$value$options : null
      }
    };
  },
  computed: {
    validItemsNumber() {
      var _this$newField$option, _this$newField$option2;
      return this.newField.type !== "dropdown" || !!((_this$newField$option = this.newField.options) != null && (_this$newField$option2 = _this$newField$option.items) != null && _this$newField$option2.length);
    },
    disableSave() {
      return !this.isValidWithWarnings || !this.validItemsNumber || this.editing;
    }
  },
  watch: {
    "newField.type"(val) {
      if (val !== "dropdown") this.newField.options = null;
    }
  },
  methods: {
    handleSubmit() {
      this.$emit("submit", this.newField);
    },
    handleCancel() {
      this.$emit("hide");
    },
    handleItemsChange(items) {
      if (this.newField.type !== "dropdown") return;
      this.newField.options = {
        items
      };
    },
    handleEditing(editing) {
      this.editing = editing;
    }
  }
});